import React, {useCallback} from 'react';
import {
    Button,
    Flex,
    PriorityIcon,
    withDropdownContext
} from '@priority-software/priority-style-react';
import styles from './style.module.scss';
import texts from '../../../../components/Common/SelectListModal/text';

type Props = {
    handleAccept: (focusedItem: number) => void;
    handleClose: () => void;
    handleShowHelpMessage: (param?) => void;
    helpButtonRef: React.RefObject<HTMLButtonElement>;
    dropdownContext: any;
};

export const Footer = withDropdownContext(
    ({dropdownContext, handleAccept, handleClose, handleShowHelpMessage, helpButtonRef}: Props) => {
        const {focusedItem} = dropdownContext;
        const onHelpClick = useCallback(
            () => handleShowHelpMessage(focusedItem),
            [focusedItem, handleShowHelpMessage]
        );

        const onAccept = useCallback(() => {
            handleAccept(focusedItem);
        }, [focusedItem, handleAccept]);

        return (
            <Flex justifyContent="space-between" componentClasses={styles.footer}>
                <Flex justifyContent="flex-start" componentClasses={styles.btnContainer}>
                    <Button
                        width="fullWidth"
                        componentClasses={styles.acceptButton}
                        onClick={onAccept}
                        size="medium"
                        skin="primary"
                    >
                        {texts.ok}
                    </Button>
                    <Button
                        onClick={handleClose}
                        name="cancel"
                        size="medium"
                        skin="secondary"
                        width="fullWidth"
                    >
                        {texts.cancel}
                    </Button>
                </Flex>
                <Button
                    componentClasses={styles.questionCircle}
                    onClick={onHelpClick}
                    prefixIcon={PriorityIcon.questionCircle}
                    size="medium"
                    skin="text"
                    name="help"
                    inputRef={helpButtonRef}
                ></Button>
            </Flex>
        );
    }
);
